var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isDisabled
      ? _c("p", { staticClass: "font-weight-bold text-color" }, [
          _vm._v("\n        " + _vm._s(_vm.getSubText) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-row flex-wrap w-100" },
      [
        _c("TextInput", {
          staticClass: "mr-3 w-75",
          attrs: {
            type: "text",
            name: "emailInput",
            "has-error": _vm.hasError,
            "current-error": _vm.errorMessage,
            label: "me@example.edu",
            icon: "far fa-envelope",
            disabled: _vm.isDisabled,
          },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
        _vm._v(" "),
        _c("ButtonWithLoadingState", {
          staticClass:
            "pr-4 font-weight-bold text-white btn btn-lg btn-success align-self-center text-uppercase mt-3 mt-sm-0",
          attrs: {
            text: _vm._f("trans")("Get Started"),
            "is-state-loading": _vm.isSubmitting,
            disabled: _vm.isUserEducational || _vm.isDisabled,
          },
          on: {
            click: _vm.submitForValidation,
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.submitForValidation.apply(null, arguments)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }